/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from "react";

// Libraries
// Molecules
import useTranslation from "@languages/useTranslation";
import { ActionDialog } from "src/atoms";
import { useAuth } from "@hooks/useAuth";
import { api } from "@store/services/rest";
import { Lgpd } from "@interfaces/lgpd.interface";
import { useToast } from "@npm-telluria-tecnologia/telluria-ui";
import { GlobalMessages } from "@languages/interfaces";

const LgpdDialog: React.FC = () => {
  const { t } = useTranslation();
  const { user, signOut, getDecodedToken, updateUser } = useAuth();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [lastLgpd, setLastLgpd] = useState<Lgpd | null>(null);

  const { addToast } = useToast();

  const handleAcceptTerm = async () => {
    try {
      const userId = getDecodedToken().primarysid;

      await api
        .patch("/user/update", {
          id: userId,
          active: true,
          lastDataShareAccept: new Date()
        })
        .then((response) => {
          localStorage.setItem(
            "@Topcon:lastDataShareAccept",
            response.data.result.lastDataShareAccept
          );
          // Sync the auth context so the in-memory `user` reflects the just
          // accepted term. Without this, leaving and returning to /dashboard
          // would remount LgpdDialog and reopen it because `user.lastDataShareAccept`
          // in context was still stale (only localStorage had been updated).
          updateUser();
          setIsDialogOpen(false);
        });
    } catch (e) {
      addToast({
        type: "error",
        title: e.message
      });
    }
  };

  const handleRefuseTerm = async () => {
    signOut();
  };

  useEffect(() => {
    try {
      api.get("/lgpd/getlast").then((res) => setLastLgpd(res.data.result));
    } catch (e) {
      addToast({
        type: "error",
        title: e.message
      });
    }
  }, []);

  useEffect(() => {
    // Verify if user has already accepted the last lgpd term, if this term exists
    if (
      lastLgpd?.createdAt
      && (!user.lastDataShareAccept
        || user.lastDataShareAccept < lastLgpd.createdAt)
    ) setIsDialogOpen(true);
  }, [lastLgpd, user]);

  return (
    <ActionDialog
      onClose={() => {}}
      actions={[
        {
          text: t(GlobalMessages.buttonAccept),
          action: () => {
            handleAcceptTerm();
          }
        },
        {
          text: t(GlobalMessages.buttonReject),
          action: () => {
            handleRefuseTerm();
          }
        }
      ]}
      title={t(GlobalMessages.lgpdTitle)}
      open={isDialogOpen}
    >
      <div dangerouslySetInnerHTML={{ __html: lastLgpd?.text ?? "" }} />
    </ActionDialog>
  );
};

export default LgpdDialog;
